export const fmtEUR = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(
    Number(n || 0)
  );

export const fmtNum = (n) =>
  new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 2 }).format(Number(n || 0));

export const fmtDate = (d) => {
  if (!d) return "—";
  try {
    const dt = new Date(d);
    if (isNaN(dt)) return d;
    return dt.toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const addDaysISO = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
};

// status metadata (French)
export const INVOICE_STATUS = {
  brouillon: { label: "À transmettre", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  envoyee: { label: "Envoyée", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  payee: { label: "Payée", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  retard: { label: "En retard", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const QUOTE_STATUS = {
  brouillon: { label: "À transmettre", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  envoye: { label: "Envoyé", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  accepte: { label: "Accepté", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  refuse: { label: "Refusé", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const RIDE_STATUS = {
  planifiee: { label: "Planifiée", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  effectuee: { label: "Effectuée", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  annulee: { label: "Annulée", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};
